module.exports = __webpack_public_path__ + "img/hiking002.e407cc25.jpg";